import React, { Component, useContext, useEffect, useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import dogpic from './images/logo1.jpg'
import './css_files/profile.css'
import DogCard from './dog_card';
import Card from './card';
import axios from 'axios';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { url } from '../weburl';
import { Search } from './search';

import ListIcon from '@mui/icons-material/List'; import { ProfileFooter } from './profile_footer';
import { BeatLoader } from 'react-spinners';
import CountryContext from './country_context';
import { Profile_Not_Logged_In } from './profile_not_logged_in';
import Footer from './footer';
import { PedShareForm } from './pedshareus';
import { dogUrlGenerator } from '../../util.js/dogUrlGenerator';
import { SearchNewForPage } from './search_new_page';
import ProfileNav from './profile-nav';
import DogCardList from './dog-card-list';
import { Button } from '@mui/material';
import { NavTest, ProfileNavSidePane } from './profile-nav-side-pane';
import { NavTest3 } from './profile-nav3';
import { ProfileNavMobile } from './profile-nav-mobile';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ProfileWrapper } from './profile-wrapper';


const Profile = (props) => {
    const context = useContext(CountryContext)
    const [dogs, setDogs] = useState([])
    const [user, setUser] = useState({})
    const [numberOfDogs, setNumberOfDogs] = useState(0)
    const [listView, setListView] = useState(false)
    const [mobileView, setMobileView] = useState(false)
    const matches = useMediaQuery('(max-width:770px)');

    useEffect(() => {
        console.log('width changed')
        if (matches) {
            setMobileView(true)
        }
        else {
            setMobileView(false)
        }

    }, [matches])
    useEffect(() => {
        refreshList()
    }, [context, context.user_sql_details])

    useEffect(() => {
        console.log('setting dogs')
    }, [dogs])

    const refreshList = () => {
        if (context.user_sql_details) {
            axios
                .get(`${url}api/dogs/getdoguser/${context.user_sql_details.id}`)
                .then((res) => {
                    console.log('here')
                    setDogs(res.data)
                    setNumberOfDogs(res.data.length)
                }
                )
                .catch((err) => {
                    console.log("Error couldnt get Dog");
                    console.log(err.message);
                });
        }

    };

    const renderDogs = () => {
        if (dogs) {
            if (!listView) {
                return dogs.map((dog) => {
                    if (dog.id != 404) {
                        return <div className=' col-10 col-md-4 col-lg-3
                    text-capitalize render_card'>
                            {/* <Link to={`/my_dogs/${dog.id}/${dogUrlGenerator(dog.name)}`}> */}
                            <DogCard image_src={dogpic} dog_id={dog.id}
                                dogname={dog.name} dog_public_id={dog.public_id}
                                date_registered={dog.date_registered} ableToBeEditted={true} />
                            {/* </Link> */}
                        </div>
                    }
                    else {
                        <p className='text-dark'>You have no dogs registered</p>

                    }

                })
            }
            else {

                return dogs.map((dog) => {
                    if (dog.id != 404) {
                        return <div className=' col-10 col-md-4 col-lg-
                    text-capitalize render_card'>
                            <Link to={`/my_dogs/${dog.id}/${dogUrlGenerator(dog.name)}`}>
                                <DogCardList image_src={dogpic} dog_id={dog.id}
                                    dogname={dog.name} dog_public_id={dog.public_id}
                                    date_registered={dog.date_registered} />
                            </Link>
                        </div>
                    }
                    else {
                        <p className='text-dark'>You have no dogs registered</p>

                    }

                })
            }
        }
        else {

        }
    }





    return (


        <ProfileWrapper>
            <div className='row align-items-center 
                            
                            justify-content-between'>
                <div className='col-md-4 text-left '>
                    <div className='row text-left align-items-center justify-content-centerd'>
                        <Link to='/registration' className='new-button px-3 py-1'>
                            Add
                        </Link>
                        <Button onClick={e => setListView(!listView)} sx={{ color: "#ba8108" }}><ListIcon /></Button>

                        <div className='text-dark' style={{ fontSize: "1rem" }}>
                            <span className='font-weight-bold'>{numberOfDogs}</span> dogs</div>
                    </div>
                </div>

                <div className='col-md-5 w-100 '>
                    <SearchNewForPage setDogs={setDogs} searchUnderSpecificUser={true} />
                </div>

            </div >
            <div className='row align-items-center justify-content-center'>
                <div className=''>

                    <div className='row align-items-start 
                                     justify-content-center justify-content-sm-start mt-3 '>

                        {renderDogs()}
                        {!dogs[0] &&
                            <div className='d-flex flex-column col-md-10 w-100 view_height_100 
                                             justify-content-center text-center'>
                                <h3 className='text-dark'>You have no registered dogs yet.</h3>
                                <p className='m-0 text-dark '>&#128517;Like to
                                    <Link class="text-warning" to="/registration"> register </Link>
                                    one with us?</p>
                            </div>}
                    </div>

                    {window.screen.width < 660 && <ProfileFooter navbarcolor='white' />}
                </div>

            </div>



        </ProfileWrapper>



    )



}



export default Profile;